<script setup lang="ts">
import { BtnPrimary } from '@shared/ui/buttons'

import { useExtraRatesStore } from '../../model/extra-rates/store'
import { useExtraRatesSaveApi } from '../../api/demo-slots/extra-rates-save.hook'

defineOptions({
  name: 'BtnExtraRatesSave',
})

const extraRatesStore = useExtraRatesStore()

const setSave = async (): Promise<void> => {
  await useExtraRatesSaveApi()
}
</script>

<template>
  <BtnPrimary
    text="Save"
    color="emerald"
    :disabled="extraRatesStore.isSaving"
    @click="setSave"
  />
</template>
